import { render, staticRenderFns } from "./allowanceInfo.vue?vue&type=template&id=95bb414c&scoped=true&"
import script from "./allowanceInfo.vue?vue&type=script&lang=js&"
export * from "./allowanceInfo.vue?vue&type=script&lang=js&"
import style0 from "./allowanceInfo.vue?vue&type=style&index=0&id=95bb414c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bb414c",
  null
  
)

export default component.exports